export enum ReliabilityFofStatus {
  Open = 1,
  Confirmed = 2,
  Rejected = 3,
  NotFof = 4,
}

export const ReliabilityFoFChoices = [
  { key: "OPEN", value: ReliabilityFofStatus.Open },
  { key: "CONFIRMED", value: ReliabilityFofStatus.Confirmed },
  { key: "REJECTED", value: ReliabilityFofStatus.Rejected },
  { key: "NOT FOF", value: ReliabilityFofStatus.NotFof },
];
